var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjectIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 20.0001H3C2.73459 20.0027 2.47935 19.898 2.29233 19.7097C2.10531 19.5214 2.0024 19.2654 2.007 19H2V5C2 3.89543 2.89543 3 4 3H10C10.2234 3.00021 10.4402 3.0752 10.616 3.213L12.9 5H18C19.1046 5 20 5.89543 20 7V11H21C21.3361 11 21.6498 11.169 21.8348 11.4496C22.0198 11.7302 22.0514 12.0851 21.919 12.394L18.919 19.394C18.7614 19.7616 18.4 20.0001 18 20.0001ZM6.66 13L4.517 18H17.341L19.484 13H6.66ZM4 7V14.13L5.081 11.606C5.23858 11.2384 5.60004 11 6 11H18V7H4Z",
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectIcon);
export default __webpack_public_path__ + "static/media/project-icon.68c4c84a617fc956ec66fe9d644749f2.svg";
export { ForwardRef as ReactComponent };